import { PoolAsset } from '../constants/poolAssets'
import { bn } from 'shared/utils/bignumber'

const COMA_DIGITS: Record<string, number | undefined> = {
  USD: 2,
  ETH: 4,
  MATIC: 4,
  // [PoolAsset.DAI]: 2,
  [PoolAsset.WETH]: 4,
  [PoolAsset.USDC]: 2,
  // [PoolAsset.USDT]: 2,
  // [PoolAsset.WBTC]: 4,
}

export function formatAsset(
  value: bn | string | number | undefined | null,
  asset: PoolAsset | string | undefined,
) {
  if (
    asset === '' ||
    asset === undefined ||
    value === null ||
    value === undefined
  ) {
    return value
  }

  const commaDigits = COMA_DIGITS[asset]
  if (commaDigits === undefined) return value
  const val =
    typeof value === 'string' || typeof value === 'number'
      ? new bn(value || 0)
      : value

  const minValue = 1 / 10 ** commaDigits
  if (val.isGreaterThan(0) && val.isLessThan(minValue)) {
    return `<${minValue}`
  }

  return val.toFixed(commaDigits)
}
